export const BECOME_A_PARTNER_STRINGS = {
  en: {
    META_TITLE: 'Become a partner',
    TITLE:
      'Do you want to take your business to the next level with Bruce Studios?',
    FORM_TITLE: 'Interested in becoming a partner?',
    INPUT_STUDIO_NAME: 'Studio name*',
    INPUT_WEBSITE: 'Website',
    INPUT_CONTACT_PERSON: 'Contact person*',
    INPUT_EMAIL: 'Email*',
    SELECT_CITY: 'City*',
    OPTION_OTHER: 'Other',
    INPUT_CITY_NAME: 'City*',
    INPUT_CITY_NAME_REQUIRED:
      'City name is required when city is set to other.',
    INPUT_PHONE: 'Phone*',
    INPUT_CLASSES_PER_WEEK:
      'How many classes/week would you like to offer Bruce Studios?*',
    SELECT_BOOKING_SYSTEM: 'What booking system are you using?',
    INPUT_BOOKING_SYSTEM_NAME: 'Booking system name',
    INPUT_BOOKING_SYSTEM_NAME_REQUIRED:
      'Booking system name is required when booking system is set to other.',
    OPTION_NONE: 'None',
    SEND_BUTTON: 'Send',
    USPS: [
      {
        ICON: 'ph-users-three',
        TITLE: 'Reach new customers',
        DESCRIPTION:
          'Through our members you can reach a wider audience and get increased exposure',
      },
      {
        ICON: 'ph-coins',
        TITLE: 'Increase your revenue',
        DESCRIPTION:
          'Bruce Studios fills your empty spots and you get paid for each visit',
      },
      {
        ICON: 'ph-desktop',
        TITLE: 'Dashboard included',
        DESCRIPTION:
          'With our dashboard it is easy to get an overview and optimizing your business',
      },
    ],
    OUR_PARTNERS: 'Our partners',
    FAQ_TITLE: 'Frequently asked questions',
    REQUEST_SENT: 'Request has been sent to us',
    WE_WILL_CONTACT_YOU:
      'Your request has now reached our studio team, and we\'ll get back to you faster than you can say "Bruce Studios"! Stay tuned, we\'ll keep in touch!',
  },
  sv: {
    META_TITLE: 'Bli partner',
    TITLE:
      'Vill du ta din verksamhet till nästa nivå tillsammans med Bruce Studios? ',
    FORM_TITLE: 'Intresserad av att bli partner?',
    INPUT_STUDIO_NAME: 'Studionamn*',
    INPUT_WEBSITE: 'Hemsida',
    INPUT_CONTACT_PERSON: 'Kontaktperson*',
    INPUT_EMAIL: 'E-post*',
    SELECT_CITY: 'Stad*',
    OPTION_OTHER: 'Annat',
    INPUT_CITY_NAME: 'Stad*',
    INPUT_CITY_NAME_REQUIRED: 'Namn på stad krävs när stad är satt till annat.',
    INPUT_PHONE: 'Telefonnummer*',
    INPUT_CLASSES_PER_WEEK: 'Hur många pass/vecka erbjuder ni Bruce Studios?*',
    SELECT_BOOKING_SYSTEM: 'Vad har ni för bokningssystem?',
    INPUT_BOOKING_SYSTEM_NAME: 'Bokningssystem',
    INPUT_BOOKING_SYSTEM_NAME_REQUIRED:
      'Namn på bokningssystem krävs när bokningssystem är satt till annat.',
    OPTION_NONE: 'Inget',
    SEND_BUTTON: 'Skicka',
    USPS: [
      {
        ICON: 'ph-users-three',
        TITLE: 'Nå nya kunder',
        DESCRIPTION:
          'Genom vår medlemsbas når ni en bredare målgrupp och får ökad exponering',
      },
      {
        ICON: 'ph-coins',
        TITLE: 'Öka era intäkter',
        DESCRIPTION:
          'Bruce Studios fyller era tomma platser och ni får betalt för varje besök',
      },
      {
        ICON: 'ph-desktop',
        TITLE: 'Dashboard utan kostnad',
        DESCRIPTION:
          'Med vår dashboard är det enkelt att få överblick och optimera verksamheten',
      },
    ],
    OUR_PARTNERS: 'Våra partners',
    FAQ_TITLE: 'Vanliga frågor',
    REQUEST_SENT: 'Förfrågan har skickats till oss',
    WE_WILL_CONTACT_YOU:
      'Din förfrågan har nu nått vårt studioteam, och vi återkommer till dig snabbare än du hinner säga “Bruce Studios”! Håll utkik, vi hörs snart!',
  },
  nb: {
    META_TITLE: 'Bli en partner',
    TITLE: 'Vil du ta bedriften din til neste nivå med Bruce Studios?',
    FORM_TITLE: 'Interessert i å bli partner?',
    INPUT_STUDIO_NAME: 'Navn på studio*',
    INPUT_WEBSITE: 'Nettside',
    INPUT_CONTACT_PERSON: 'Kontaktperson*',
    INPUT_EMAIL: 'E-post*',
    SELECT_CITY: 'By*',
    OPTION_OTHER: 'Annet',
    INPUT_CITY_NAME: 'By*',
    INPUT_CITY_NAME_REQUIRED: 'Bynavn er påkrevd når by er satt til annet.',
    INPUT_PHONE: 'Telefonnummer*',
    INPUT_CLASSES_PER_WEEK:
      'Hvor mange gruppetimer/uke tilbyr dere Bruce Studios?*',
    SELECT_BOOKING_SYSTEM: 'Hvilket bookingsystem bruker dere?',
    INPUT_BOOKING_SYSTEM_NAME: 'Bookingsystem',
    INPUT_BOOKING_SYSTEM_NAME_REQUIRED:
      'Bookingsystemnavn er påkrevd når bookingsystem er satt til annet.',
    OPTION_NONE: 'Ingen',
    SEND_BUTTON: 'Send',
    USPS: [
      {
        ICON: 'ph-users-three',
        TITLE: 'Nå nye kunder',
        DESCRIPTION:
          'Gjennom vår medlemsbase kan dere nå en bredere målgruppe og få økt eksponering',
      },
      {
        ICON: 'ph-coins',
        TITLE: 'Øk inntektene dine',
        DESCRIPTION:
          'Bruce Studios fyller de tomme plassene dine og du får betalt for hvert besøk',
      },
      {
        ICON: 'ph-desktop',
        TITLE: 'Dashboard inkludert',
        DESCRIPTION:
          'Med vår dashboard er det enkelt å få oversikt og optimalisere bedriften din',
      },
    ],
    OUR_PARTNERS: 'Våre partnere',
    FAQ_TITLE: 'Vanlige spørsmål',
    REQUEST_SENT: 'Forespørselen din er nå sendt til oss',
    WE_WILL_CONTACT_YOU:
      'Forespørselen din har nådd studioteamet vårt, og vi vil komme tilbake til deg raskere enn du kan si "Bruce Studios"! Følg med, vi høres snart!',
  },
  da: {
    META_TITLE: 'Bliv partner',
    TITLE: 'Vil du tage din virksomhed til næste niveau med Bruce Studios?',
    FORM_TITLE: 'Interesseret i at blive partner?',
    INPUT_STUDIO_NAME: 'Navn på studio*',
    INPUT_WEBSITE: 'Hjemmeside',
    INPUT_CONTACT_PERSON: 'Kontaktperson*',
    INPUT_EMAIL: 'E-mail*',
    SELECT_CITY: 'By*',
    OPTION_OTHER: 'Andet',
    INPUT_CITY_NAME: 'By*',
    INPUT_CITY_NAME_REQUIRED: 'Bynavn er påkrævet, når by er sat til andet.',
    INPUT_PHONE: 'Telefonnummer*',
    INPUT_CLASSES_PER_WEEK: 'Hvor mange hold/uge tilbyder i Bruce Studios?*',
    SELECT_BOOKING_SYSTEM: 'Hvilket bookingsystem bruger i?',
    INPUT_BOOKING_SYSTEM_NAME: 'Bookingsystem',
    INPUT_BOOKING_SYSTEM_NAME_REQUIRED:
      'Bookingsystemnavn er påkrævet, når bookingsystem er sat til andet.',
    OPTION_NONE: 'Ingen',
    SEND_BUTTON: 'Send',
    USPS: [
      {
        ICON: 'ph-users-three',
        TITLE: 'Nå nye kunder',
        DESCRIPTION:
          'Gennem vores medlemsbase kan i nå en bredere målgruppe og få øget eksponering',
      },
      {
        ICON: 'ph-coins',
        TITLE: 'Øg indtægterne',
        DESCRIPTION:
          'Bruce Studios fylder jeres tomme pladser og i får betalt for hvert besøg',
      },
      {
        ICON: 'ph-desktop',
        TITLE: 'Dashboard inkluderet',
        DESCRIPTION:
          'Med vores dashboard er det nemt at få overblik og optimere jeres virksomhed',
      },
    ],
    OUR_PARTNERS: 'Vores partnere',
    FAQ_TITLE: 'Ofte stillede spørgsmål',
    REQUEST_SENT: 'Henvendelsen er sendt til os',
    WE_WILL_CONTACT_YOU:
      'Din henvendelse har nu nået vores studieteam og vi vender tilbage til dig hurtigere, end du kan sige "Bruce Studios"! Følg med, vi tales snart ved!',
  },
} as const
